import { useEffect, useState } from "react";
import ProjectCard from "../../components/ProjectCard";
import CreateProjectCard from "../../components/CreateProjectCard";
import axios from "axios";
import Header from "../../components/Header";
import DeleteProject from "../../components/DeleteProject";

export default function Dashboard() {
  const [projects, setProjects] = useState([]);
  const [open, setOpen] = useState({
    isOpen: false,
    currentOpen: "",
  });
  useEffect(() => {
    const getData = async () => {
      const res = await axios.get(
        `${process.env.REACT_APP_URL}/api/v1/dashboard/view-project`
      );
      setProjects(res.data.projects);
    };
    getData();
  }, []);
  const handleClick = async (action) => {
    if (action !== "cancel") {
      const res = await axios.delete(
        `${process.env.REACT_APP_URL}/api/v1/dashboard/${open.currentOpen}`
      );
      setProjects(res.data.projects);
    }
    setOpen((open) => {
      return { ...open, isOpen: !open.isOpen };
    });
  };
  const handleOpenState = (event, action) => {
    event.preventDefault();
    setOpen((open) => {
      return { ...open, isOpen: !open.isOpen, currentOpen: action };
    });
  };
  return (
    <>
      <div
        className={`min-h-full w-full overflow-y-auto mycustom-scroll ${
          open.isOpen ? "" : ""
        }`}
      >
        <Header />
        <main>
          <div className="max-w-80percent mx-auto py-6 sm:px-6 lg:px-8">
            <div className="mt-6 space-y-12 lg:grid lg:grid-cols-4 lg:gap-x-6 lg:space-y-0">
              <CreateProjectCard />
              {projects.map((project) => (
                <ProjectCard
                  key={project._id}
                  project={project}
                  handleOpenState={handleOpenState}
                />
              ))}
            </div>
          </div>
          {open.isOpen && <DeleteProject handleClick={handleClick} />}
        </main>
      </div>
    </>
  );
}
